export const PLAYER_EVENT = {
  PLAY: 'play',
  PLAYING: 'playing',
  PAUSE: 'pause',
  SEEK: 'seek',
  SEEKING: 'seeking',
  MUTE: 'mute',
  UNMUTE: 'unmute',
  PAUSE_NO_SEEK: 'pausenoseek',
  ERROR: 'error',
  TIME_UPDATE: 'timeupdate',
  RETRY_PLAYLIST: 'retryplaylist',
  CAN_PLAY_THROUGH: 'canplaythrough',
  CLD_SOURCE_CHANGED: 'cldsourcechanged',
  SOURCE_CHANGED: 'sourcechanged',
  LOADED_METADATA: 'loadedmetadata',
  LOADED_DATA: 'loadeddata',
  REFRESH_TEXT_TRACKS: 'refreshTextTracks',
  PLAYLIST_CREATED: 'playlistcreated',
  UP_COMING_VIDEO_SHOW: 'upcomingvideoshow',
  UP_COMING_VIDEO_HIDE: 'upcomingvideohide',
  PLAYLIST_ITEM_CHANGED: 'playlistitemchanged',
  VOLUME_CHANGE: 'volumechange',
  FLUID: 'fluid',
  PLAYLIST_PANEL: 'PlaylistPanel',
  ENDED: 'ended',
  RESIZE: 'resize',
  START: 'start',
  VIDEO_LOAD: 'videoload',
  PRODUCT_BAR_MIN: 'productBarMin',
  SHOW_PRODUCTS_OVERLAY: 'showProductsOverlay',
  SHOPPABLE_ITEM_CHANGED: 'shoppableitemchanged',
  FULL_SCREEN_CHANGE: 'fullscreenchange',
  PERCENTS_PLAYED: 'percentsplayed',
  TIME_PLAYED: 'timeplayed',
  PLAYER_LOAD: 'playerload',
  DISPOSE: 'dispose',
  QUALITY_CHANGED: 'qualitychanged'
};

export const SOURCE_TYPE = {
  AUDIO: 'AudioSource',
  VIDEO: 'VideoSource'
};
